import { Y42FeatureType } from '@y42/json-schema';
import { AssetSidebarTab, AssetSidebarTabType } from './asset-sidebar-tab.model';

export const ASSET_SIDEBAR_TABS: Record<AssetSidebarTabType, AssetSidebarTab> = {
  [AssetSidebarTabType.Overview]: {
    label: 'Information',
    type: AssetSidebarTabType.Overview,
    logo: 'info-circle',
    isFontAwesome: true,
    componentDef: {
      module: () =>
        import('./components/asset-sidebar-overview/asset-sidebar-overview.module').then(
          (m) => m.AssetSidebarOverviewModule,
        ),
      component: () =>
        import('./components/asset-sidebar-overview/asset-sidebar-overview.component').then(
          (c) => c.AssetSidebarOverviewComponent,
        ),
    },
  },
  [AssetSidebarTabType.Metadata]: {
    label: 'Metadata',
    type: AssetSidebarTabType.Metadata,
    logo: 'pencil',
    isFontAwesome: true,
    componentDef: {
      module: () =>
        import('./components/asset-sidebar-metadata/asset-sidebar-metadata.module').then(
          (m) => m.AssetSidebarMetadataModule,
        ),
      component: () =>
        import('./components/asset-sidebar-metadata/asset-sidebar-metadata.component').then(
          (c) => c.AssetSidebarMetadataComponent,
        ),
    },
  },
  [AssetSidebarTabType.Comment]: {
    label: 'Comments',
    type: AssetSidebarTabType.Comment,
    logo: 'comment',
    isFontAwesome: true,
    componentDef: {
      module: () =>
        import('./components/asset-sidebar-comment/asset-sidebar-comment.module').then(
          (m) => m.AssetSidebarCommentModule,
        ),
      component: () =>
        import('./components/asset-sidebar-comment/asset-sidebar-comment.component').then(
          (c) => c.AssetSidebarCommentComponent,
        ),
    },
  },
  [AssetSidebarTabType.ACL]: {
    label: 'Access Control',
    type: AssetSidebarTabType.ACL,
    logo: 'user-lock',
    isFontAwesome: true,
    componentDef: {
      module: () =>
        import('./components/asset-sidebar-acl/asset-sidebar-acl.module').then((m) => m.AssetSidebarAclModule),
      component: () =>
        import('./components/asset-sidebar-acl/asset-sidebar-acl.component').then((c) => c.AssetSidebarAclComponent),
    },
  },
  [AssetSidebarTabType.Lineage]: {
    label: 'Lineage',
    type: AssetSidebarTabType.Lineage,
    logo: 'list-tree',
    isFontAwesome: true,
    componentDef: {
      module: () =>
        import('./components/asset-sidebar-lineage/asset-sidebar-lineage.module').then(
          (m) => m.AssetSidebarLineageModule,
        ),
      component: () =>
        import('./components/asset-sidebar-lineage/asset-sidebar-lineage.component').then(
          (c) => c.AssetSidebarLineageComponent,
        ),
    },
    hidden: (asset) => asset?.featureType === Y42FeatureType.Orchestration ?? false,
  },
  [AssetSidebarTabType.Delete]: {
    label: 'Delete Asset',
    type: AssetSidebarTabType.Delete,
    logo: 'trash-can',
    isFontAwesome: true,
    componentDef: {
      module: () =>
        import('./components/asset-sidebar-delete/asset-sidebar-delete.module').then((m) => m.AssetSidebarDeleteModule),
      component: () =>
        import('./components/asset-sidebar-delete/asset-sidebar-delete.component').then(
          (c) => c.AssetSidebarDeleteComponent,
        ),
    },
  },
};
